// Copyright (c) billwerk GmbH. All rights reserved.
'use strict';

var AccountSetupController = function ($scope, $routeParams, $rootScope, $location, $http, $q, AccountSetup, CheckPasswordStrength, Throttle, gettextCatalog, gettext, $window, UserSettings, Features, Permissions, LegalEntity) {
    useQueryParamsLang($routeParams, gettextCatalog);

    AccountSetup.get($routeParams.token)
        .then(function (response) {
            $scope.accountsetup = response.data;
        });

    $scope.accessToken = "";
    $scope.refreshToken = "";
    var estimationResult = Throttle(CheckPasswordStrength, 1000, function (response) {
        $scope.estimationResult = response.data;
    });

    $scope.preview = function () {
        var checkPasswordData = { password: $scope.accountsetup.Password, token: $routeParams.token }
        estimationResult.request(checkPasswordData);
    };
    $scope.save = function () {
        if (!$rootScope.isValid($scope.form)) {
            return;
        }

        var isInternal = $scope.accountsetup.AcceptTermsOfUse;
        AccountSetup.save($routeParams.token, isInternal ? 'api/v1/internalsignup/' : 'api/v1/signup/', $scope.accountsetup)
            .then(function () {
                $http({//todo: remove duplication
                    method: "POST",
                    url: baseUrl + "oauth/token",
                    params: null,
                    data: {
                        "username": $scope.accountsetup.EmailAddress,
                        "password": $scope.accountsetup.Password,
                        "client_id": "51014335eb596a0e149f2b36",
                        "grant_type": "password"
                    },
                    headers: { "Content-Type": "application/x-www-form-urlencoded" },
                    transformRequest: transform,
                    cache: false
                }).then(function (response) {
                    var data = response.data;
                    $scope.password = null;
                    if (data["access_token"]) {
                        $rootScope.accessToken = data["access_token"];
                        $rootScope.refreshToken = data["refresh_token"];
                        $rootScope.username = $scope.accountsetup.EmailAddress;
                        $http.defaults.headers.common["Authorization"] = "Bearer " + data["access_token"];
                        localStorage.setItem('username', $rootScope.username);
                        localStorage.setItem('access_token', $rootScope.accessToken);
                        localStorage.setItem('refresh_token', $rootScope.refreshToken);
                        UserSettings.get(function (data) {
                            localStorage.setItem("culture", data.Culture);
                            localStorage.setItem("first_name", data.FirstName);
                            localStorage.setItem("last_name", data.LastName);
                            localStorage.setItem("email", data.Email);
                            $scope.setLang(data.Culture);
                        });
                        localStorage.setItem("culture", $scope.accountsetup.Language || 'de');

                        $q.all([
                            Features.reload(),
                            LegalEntity.reload(),
                            Permissions.reload(),
                        ]).then(function () {
                            if ($scope.accountsetup.UserConfirmationRedirectUrl) {
                                $window.location.href = $scope.accountsetup.UserConfirmationRedirectUrl +
                                    "?FIRSTNAME=" +
                                    $scope.accountsetup.FirstName +
                                    "&LASTNAME=" +
                                    $scope.accountsetup.LastName +
                                    "&EMAIL=" +
                                    $scope.accountsetup.EmailAddress +
                                    "&COMPANY=" +
                                    $scope.accountsetup.CompanyName;
                            } else {
                                $location.path($rootScope.defaultLocation());
                            }

                        });
                    }
                });
                $scope.password = null;
            });
    };

    function useQueryParamsLang($routeParams, gettextCatalog) {
        if ($routeParams.language) {
            gettextCatalog.currentLanguage = $routeParams.language;
        }
    }
};
AccountSetupController.$inject = ['$scope', '$routeParams', '$rootScope', '$location', '$http', '$q', 'AccountSetup', 'CheckPasswordStrength', 'Throttle', 'gettextCatalog', 'gettext', '$window', 'UserSettings', 'Features', 'Permissions', 'LegalEntity'];
